import { useState } from 'react';
import {IMAGE_URL} from "../../../path";

type Props = {
    range?: any;
    onClose: () => void;
    onSave: (data: any) => void;
};

export default function RangeModal({
                                       range,
                                       onClose,
                                       onSave,
                                   }: Props) {

    const [name, setName] =
        useState(
            range?.name || ''
        );

    const [isActive, setIsActive] =
        useState(
            range?.is_active ?? true
        );

    const [displayName, setDisplayName] =
        useState(
            range?.display_name || ''
        );

    const [shortDescription, setShortDescription] =
        useState(
            range?.short_description || ''
        );

    const [headerBody, setHeaderBody] =
        useState(
            range?.header_body || ''
        );

    const [headerImage, setHeaderImage] =
        useState<File | null>(null);

    const [headerPreview, setHeaderPreview] =
        useState(
            range?.header_image
                ? `${IMAGE_URL}/${range.header_image}`
                : ''
        );

    const [coverImage, setCoverImage] =
        useState<File | null>(null);

    const [coverPreview, setCoverPreview] =
        useState(
            range?.cover_image
                ? `${IMAGE_URL}/${range.cover_image}`
                : ''
        );


    const handleSubmit = (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        onSave({

            name,

            is_active:
            isActive,

            display_name:
            displayName,

            short_description:
            shortDescription,

            cover_image:
            coverImage,

            header_body:
            headerBody,

            header_image:
            headerImage,

        });
    };

    return (

        <div
            className="modal-overlay"
            onClick={onClose}
        >

            <div
                className="modal-box"
                onClick={(e) => e.stopPropagation()}
            >

                <h2>

                    {range
                        ? 'Edit Range'
                        : 'Add Range'}

                </h2>

                <form
                    className="modal-form"
                    onSubmit={
                        handleSubmit
                    }
                >

                    <label>
                        Name
                    </label>

                    <input
                        type="text"
                        value={name}
                        onChange={(e) =>
                            setName(
                                e.target.value
                            )
                        }
                        required
                    />
                    <label>
                        Display Name
                    </label>

                    <input
                        type="text"
                        value={displayName}
                        onChange={(e) =>
                            setDisplayName(
                                e.target.value
                            )
                        }
                        required
                    />

                    <label>
                        Short Description
                    </label>

                    <textarea
                        value={shortDescription}
                        onChange={(e) =>
                            setShortDescription(
                                e.target.value
                            )
                        }
                        rows={3}
                    />

                    <label>
                        Category Preview Image
                    </label>

                    <p className="field-hint">
                        Maximum file size: 2MB
                    </p>

                    {coverPreview && (

                        <img
                            src={coverPreview}
                            alt=""
                            className="image-preview"
                        />

                    )}

                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {

                            const file =
                                e.target.files?.[0];

                            if (!file) {
                                return;
                            }

                            setCoverImage(
                                file
                            );

                            setCoverPreview(
                                URL.createObjectURL(
                                    file
                                )
                            );

                        }}
                    />

                    <label>
                        Header Body
                    </label>

                    <textarea
                        value={headerBody}
                        onChange={(e) =>
                            setHeaderBody(
                                e.target.value
                            )
                        }
                        rows={5}
                    />

                    <label>
                        Header Image
                    </label>

                    <p className="field-hint">
                        Maximum file size: 2MB
                    </p>

                    {headerPreview && (

                        <img
                            src={headerPreview}
                            alt=""
                            className="image-preview"
                        />

                    )}

                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {

                            const file =
                                e.target.files?.[0];

                            if (!file) {
                                return;
                            }

                            setHeaderImage(
                                file
                            );

                            setHeaderPreview(
                                URL.createObjectURL(
                                    file
                                )
                            );

                        }}
                    />

                    <label>
                        Active
                    </label>

                    <select
                        value={
                            isActive
                                ? '1'
                                : '0'
                        }
                        onChange={(e) =>
                            setIsActive(
                                e.target.value ===
                                '1'
                            )
                        }
                    >

                        <option value="1">
                            Yes
                        </option>

                        <option value="0">
                            No
                        </option>

                    </select>

                    <div className="modal-actions">

                        <div className="left-actions">

                            <button
                                type="button"
                                className="cancel-btn"
                                onClick={
                                    onClose
                                }
                            >
                                Cancel
                            </button>

                        </div>

                        <div className="right-actions">

                            <button
                                type="submit"
                                className="action-btn"
                            >
                                Save
                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </div>

    );
}
